<mat-card class="filter settingHeader">
  <div class="name">
    Manage AI Field Template
  </div>

  <div class="quickAction">   
    <mat-form-field appearance="fill">
      <mat-label>Select</mat-label>
      <mat-select (selectionChange)="OnChange3C($event)" value="1">
        <mat-option value="1">{{CoreShowName}}</mat-option>
        <mat-option value="2">{{ContactShowName}}</mat-option> 
        <mat-option value="3">{{CompanyShowName}}</mat-option>          
      </mat-select>
    </mat-form-field>
  </div>
</mat-card>

<div class="documents">

    <mat-card class="example-list rowholder">
      <div class="fieldRow head">
        <span class="moveicon"></span>       
        <span class="fieldName">Template Name</span>
        <span class="fieldName">Category Name</span>
        <span class="requried">Active/Inactive</span>
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow" *ngFor="let type of categoryList">
        <span class="moveicon"></span>        
         <span class="fieldName">{{type.tempalteName}}</span>  
         <span class="fieldName">{{type.categoryName}}</span>  
        <span class="requried">
          <mat-slide-toggle color="primary" [checked]="type.isActive" (change)="UpdateStatusToggle(type,$event)">
          </mat-slide-toggle>
        </span> 
  
        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="openDialogUpdateType(myDialog,type)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash" (click)="DeleteCategory(type)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>     
      <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
    </mat-card>

</div>


<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Template Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Template Name</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="Edit template name"  formControlName="categoryName"/>
      <mat-error
      *ngIf="formDialog.get('categoryName').invalid &&
        (formDialog.get('categoryName').dirty ||
        formDialog.get('categoryName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateCategoryNameDetails(formDialog.value)">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

